module.exports = __webpack_public_path__ + "img/mage.79e780bc.svg";